import { Editor, BeforeMount } from "@monaco-editor/react";
import * as monaco from 'monaco-editor';
import { useEffect } from "react";
import { defineCustomTheme } from "@/app/utils/monacoTheme";
import { FormattedMessage } from "react-intl";

let monacoRef: typeof monaco | null = null;

export default function MonacoEditorPreview({
  value = '',
  language = 'css',
  height = '25vh',
  isDarkMode = false,
}: {
  value: string;
  language: 'css' | 'javascript';
  height?: string;
  isDarkMode?: boolean;
}) {
  const isEmpty = !value?.trim();

  const handleEditorWillMount: BeforeMount = (monacoInstance) => {
    monacoRef = monacoInstance;
    defineCustomTheme(monacoInstance, isDarkMode);
    monacoInstance.editor.setTheme('custom-slider-theme');
  };

  useEffect(() => {
    if (monacoRef) {
      defineCustomTheme(monacoRef, isDarkMode);
      monacoRef.editor.setTheme('custom-slider-theme');
    }
  }, [isDarkMode]);

  if (isEmpty) {
    return (
      <div className="text-[#B5B5C3] font-semibold text-sm">
        <FormattedMessage id="NO_DATA_AVAILABLE" defaultMessage="No data available" />
      </div>
    );
  }

  return (
    <Editor
      height={height}
      defaultLanguage={language}
      value={value}
      theme="custom-slider-theme"
      options={{
        readOnly: true,
        minimap: { enabled: false },
      }}
      className="bg-secondary border-small border-default-200 input h-[28vh]"
      beforeMount={handleEditorWillMount}
    />
  );
}
